import React, { Component } from "react";
import { Input, NumericTextBox, MaskedTextBox, Checkbox, Switch } from "@progress/kendo-react-inputs";
import { DropDownList, ComboBox, MultiSelect } from "@progress/kendo-react-dropdowns";
import { TimePickerComponent } from "@syncfusion/ej2-react-calendars";
import { Fields } from "./AttributeTypes";
import DummyLabelHelper from "./DummyLabel"
import NumberField, { NumberDefaultValueField } from "./Fields/NumberField";
import { PicklistOptionsField, PicklistDefaultValueField } from "./Fields/PicklistStringFields";
import DateTimeTypeField from "./Fields/DateTimeTypeField";
import NumberTypeField from "./Fields/NumberTypeField";
import RelativeDateField from "./Fields/RelativeDateField";
import BooleanDefaultValueField from "./Fields/BooleanDefaultValueField";
import EditorActions from "../Shared/Edit/EditorActions";
import ErrorMessage from "../Shared/Error/ErrorMessage";
import ShowMore from "../Display/ShowMore";
import SaveDialog from "../Shared/Remove/SaveDialog";
import AttributeTypeField from "./Fields/AttributeTypeField";
import NumericInput from "./Fields/NumericInput";
import Scrollable from "../Shared/Edit/Scrollable";
import { callApiWithAuthorization } from "../../API/CallApi";
import FormulaDialog from "./FormulaDialog/FormulaDialog";
import StatesRulesDialog from "./StatesRulesDialog"
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { GlobalContext } from "../../Renderers/GlobalContext"
import { ATTRIBUTE_LABEL } from "../Helpers/Labels/AttributeLabel";
import { isLibraryOrganization } from "../Helpers/Organization/Organization";
import { StateFeildOptionsField } from "./Fields/StateFields";
import { getEntityLookupReferencedAttribute, getIsStartOrEndAttributeInGanttChart, unlinkPicklistAttribute, updateAttributeFormula, updateAttributeNode } from "../../API/Attribute/Attribute";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import TreeDropdown from "./Fields/TreeDropdown";
import { CheckErrorInTree, CheckIfTreeIsSame } from "./Fields/TreeDropdownHelper";
import { removeExtraSpaceFromTreeElement } from "./Fields/TreeDropdownHelper";
import Loader from "../Shared/Loader/loader";
import { CellFormating } from "./Fields/CellFormatting/CellFormating";
import { removeSpecialCharacters } from "../Entities/utils";
import { withTranslation } from "react-i18next";
import SharedPropertyTypeField from "./Fields/SharedPropertyTypeField";
import MirrorField from "./Fields/MirrorField";
import { uuidv4 } from "./Fields/TreeDropdownHelper";
import { createAttributeTemplate, getAttributeTemplates, updateAttributeTemplate } from "../../API/AttributeTemplate/AttributeTemplate";
import GenericTranslationDialog from "../Entities/GenericTranslationDialog";

class SidebarAttribute extends Component {
	static contextType = GlobalContext
	KendoMaskToRegexMap = {
		0: "[0-9]",
		9: "[0-9 ]",
		"#": "[0-9 +-]",
		L: "[a-zA-Z]",
		"?": "[a-zA-Z ]",
		A: "[0-9a-zA-Z]",
		a: "[0-9a-zA-Z ]",
		"&": "[^ ]",
		C: "*",
	};

	interval = ["1", "5", "10", "15", "30"];
	allowedFileTypes = ["JPEG", "PNG", "GIF", "TIFF", "SVG"];

	isLibrary = isLibraryOrganization(this.props.organisationId);
	belongsToUserProfileEntity = this.props.entityName === "User Profile";

	constructor(props) {
		super(props);
		this.state = {
			loadFormula: false,
			isAttrLoaded: false,
			disabled: true,
			showAdditionalFields: false,
			showSaveAndContinueDialog: false,
			showOverwriteTemplateDialog: false,
			showWarnigDialogForMultiSelect: false,
			showLabelTranslationDialog: false,
			showStatesRulesDialog: false,
			formFields: {},
			formula: '',
			formulaJson: '',
			triggerSetting: {},
			removeFormula: false,
			saveAsTemplate: false,
			resetFlag: false,
			groups: [],
			lookupAttributeError: false,
			isUsedInStartOrEndAttribute: false,
			errors: {
				isNameValid: true,
				isMinValid: true,
				isLabelValid: true,
				isMaxValid: true,
				isDefaultValueValid: true,
				isDefaultDateValid: true,
				isPicklistValid: true,
				isStatefieldValid: true,
				isTreedropdownValid: true,
				isPatternValid: true,
				isMaxFileSizeValid: true,
				isNumberOfAttachmentsValid: true,
				isAllowedFileTypesValid: true,
				nameError: "",
				minError: "",
				labelError: "",
				maxError: "",
				defaultValueError: "",
				defaultDateError: "",
				picklistError: "",
				treedropdownError: "",
				statefieldError: "",
				patternError: "",
				maxFileSizeError: "",
				numberOfAttachmentsError: "",
				allowedFileTypesError: ""
			},
		};
	}

	render() {
		const { disabled, showAdditionalFields, showSaveAndContinueDialog, showOverwriteTemplateDialog, showWarnigDialogForMultiSelect, showStatesRulesDialog, formFields, errors, groups, removeFormula } = this.state;

		const { onDelete } = this.props;
		const { isSystemAttribute } = this.props.SideData;
		const { subscription } = this.context.state;
		const filteredAttributes = this.props.attributes.filter(attribute => !attribute.isSystemAttribute);
		const { t } = this.props;

		return (
			<div className="overflow-hidden h-100">
				{
					this.state.loading &&
					<OverlayLoader />
				}
				{showSaveAndContinueDialog && (
					<SaveDialog
						showLoader={this.state.loading}
						Title={t("save_dialog.title")}
						message={t("save_dialog.message")}
						onSave={this.updateAttributeAndContinue}
						onCancel={this.cancelUpdatingAttribute}
						toggleSaveDialog={this.cancelUpdatingAttribute}
						SaveButtonText={t("save_dialog.buttons.save")}
						cancelButtonText={t("save_dialog.buttons.cancel")}
					/>
				)}
				{showOverwriteTemplateDialog && (
					<SaveDialog
						showLoader={this.state.loading}
						Title={t("overwrite_dialog.title")}
						message={t("overwrite_dialog.message")}
						onSave={this.overwriteTemplate}
						onCancel={this.toggleOverwriteTemplateDialog}
						toggleSaveDialog={this.toggleOverwriteTemplateDialog}
						SaveButtonText={t("overwrite_dialog.buttons.save")}
						cancelButtonText={t("overwrite_dialog.buttons.cancel")}
					/>
				)}

				{showWarnigDialogForMultiSelect && (
					<SaveDialog
						showLoader={this.state.loading}
						Title={t("multi_select_warning_dialog.title")}
						message={t("multi_select_warning_dialog.message")}
						onSave={this.updateAttribute}
						onCancel={this.toggleWarnigDialogForMultiSelect}
						toggleSaveDialog={this.toggleWarnigDialogForMultiSelect}
						SaveButtonText={t("multi_select_warning_dialog.buttons.save")}
						cancelButtonText={t("multi_select_warning_dialog.buttons.cancel")}
					/>
				)}

				{removeFormula && <RemoveDialog
					toggleDeleteDialog={this.cancelRemoveDialog}
					message={t("remove_formula_dialog.message")}
					Title={t("remove_formula_dialog.title")}
					deleteButtonText={t("remove_formula_dialog.buttons.delete")}
					currentEntity={this.props.entityId}
					onDelete={this.deleteFormula}
				/>}

				<div className="d-flex flex-column h-100">
					<div>
						<EditorActions
							header={t("editor_actions.title")}
							active={disabled}
							deleteClicked={onDelete}
							deleteDisabled={this.shouldDeleteBeDisabled()}
							disabled={isSystemAttribute}
							transactionError={[!errors.isTransactionValid && errors.transactionError]}
							saveClicked={this.updateAttributeConfirm}
							redoClicked={this.resetForm}
							saving={this.state.loading}
							hasErrors={this.hasErrors()}
							popupActions={formFields.attributeType === "Shared Lookup" || formFields.attributeType === "Entity Lookup" || formFields.attributeType === "Mirror" ?
								[]
								:
								[
									{
										text: t("editor_actions.actions.save_as_property_template"),
										icon: "save",
										onClick: this.createAttributeTemplate,
										disabled: this.shouldSaveAsAttributeTemplateBeDisabled()
									}
								]
							}
						></EditorActions>
					</div>
					{this.state.loadFormula && <Loader />}
					{this.state.loadFormula === false &&
						<Scrollable>
							<div className="pe-2 row z-index">
								<div className="col-12">
									<div className="form-label d-inline-block" required>
										{t("form.name")}
									</div>
									<ErrorMessage valid={errors.isNameValid} error={errors.nameError} />

									<div className={isSystemAttribute || this.isAzureAttributeFromUserEntity() ? "disabled-input-wrapper" : ""}>
										<input disabled={isSystemAttribute || this.isAzureAttributeFromUserEntity() || this.isEntityLookup()} maxLength={64} className={"form-control name-text font-weight-bold"} name="attributeName" value={formFields.attributeName} onChange={(e) => this.handleChange(e)} />
									</div>
								</div>
								<div className="col-12">
									<div className="form-label d-inline-block">{t("form.type")}</div>
								</div>
								<div className="pe-2 col-6">
									<AttributeTypeField attributeType={formFields.attributeType} />
								</div>
								{
									formFields.attributeType === "Mirror" && (
										<div className="col-6">
											<AttributeTypeField
												attributeType={this.getMirrorSubType()}
											/>
										</div>
									)
								}
								<div className="col-6"></div>

								{formFields.attributeType === "DateTime" && (
									<div className="col-12 mt-2">
										<DateTimeTypeField value={formFields.dateTimeType} disabled={true} />
									</div>
								)}

								{formFields.attributeType === "Number" && (
									<div className="col-12  mt-2"><NumberTypeField value={formFields.numberType} disabled={true} /></div>
								)}

								{formFields.attributeType === "Shared Lookup" && (
									<div className="col-12 mt-2">
										<SharedPropertyTypeField value={formFields.sharedLookupType} disabled={true} />
									</div>
								)}

								<div className="col-12">
									<div className="form-label d-inline-block mb-0 mt-4">{t("form.control")}</div>
									<div className="control">

										{(!(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled)) &&

											(<>
												{formFields.attributeType !== "Boolean" &&
													<Checkbox
														name="required"
														className="me-4"
														checked={formFields.required}
														label={t("form.required")}
														labelOrientation="right"
														onChange={this.handleCheckbox}
														disabled={
															isSystemAttribute ||
															formFields.readOnly ||
															formFields.attributeType === "State Field" ||
															(formFields.referenceEntity && formFields.referenceEntity._id && formFields.referenceEntity._id === this.props.entityId)
														}
													/>
												}
											</>)}

										{
											this.showReadOnly() &&
											<Checkbox
												name="readOnly"
												className="me-4"
												checked={formFields.readOnly || ((formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled) ? true : false)}
												label={t("form.read_only")}
												labelOrientation="right"
												onChange={this.handleCheckbox}
												disabled={
													isSystemAttribute ||
													formFields.required ||
													formFields.unique ||
													(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled) ||
													(this.props.isUserEntity && formFields.attributeName === "Email")
												}
											/>
										}


										{(!(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled)) &&
											!this.isAzureAttributeFromUserEntity() &&
											(<>
												{formFields.attributeType === "String" &&
													<Checkbox
														name="unique"
														className="me-4"
														checked={formFields.unique}
														label={t("form.unique")}
														labelOrientation="right"
														onChange={this.handleCheckbox}
														disabled={isSystemAttribute || formFields.readOnly}
													/>
												}
											</>)}
									</div>
								</div>

								{/* <div className="col-12">

								<Tooltip anchorElement="target" position="right" tooltipClassName="kendo-tool-tip">
									<div className="form-label d-inline-block mt-3 pt-1 "
										title={`
										You can group ${ATTRIBUTE_PLURAL_LABEL.toLowerCase()} under different sections when showing in the Form page of your app.
										`}
									>Section
										<i className="mx-1 fal fa-info-circle"
											title={`
											You can group ${ATTRIBUTE_PLURAL_LABEL.toLowerCase()} under different sections when showing in the Form page of your app.
											`}></i>
									</div>
								</Tooltip>

								<div className="col-12">
									<ComboBox placeholder="Type in new section or select existing section" className="form-control-custom" name="group" allowCustom={true} data={groups} value={formFields.group} onChange={this.handleGroupChange} disabled={isSystemAttribute} clearButton={false} />
								</div>
							</div> */}
								<div className="col-12">
									<div className="form-label d-inline-block" required>
										{t("form.label")}
									</div>
									<ErrorMessage valid={errors.isLabelValid} error={errors.labelError} />
									<div className={isSystemAttribute || this.isAzureAttributeFromUserEntity() ? "disabled-input-wrapper" : ""}>
										<input className="form-control" name="attributeLabel" value={formFields.attributeLabel} onChange={this.handleChange} disabled={isSystemAttribute || this.isAzureAttributeFromUserEntity()} />
									</div>
								</div>
								{this.props.subscription.numOfLanguages > 1 &&
									<div className="col-12">
										<div className="form-label d-inline-block cursor-pointer" onClick={() => {
											this.setState({
												showLabelTranslationDialog: true
											})
										}}>
											<span className="text-primary">
												{t("form.label_translation")}
											</span>
										</div>
									</div>
								}
								{this.state.showLabelTranslationDialog && (
									<GenericTranslationDialog
										onClose={() => {
											this.setState({
												showLabelTranslationDialog: false
											})
										}}
										onSave={this.setLabelTranslation}
										languages={this.state.formFields.languages}
										project={this.props.project}
										fields={[
											"label",
											"tooltip"
										]}
										type={t("editor_actions.property")}
									/>
								)}
								{
									this.isLibrary &&
									this.props.isInternalUser &&
									<div className="col-12">
										<div className="form-label">
											Recommendation Configuration
										</div>
										<Checkbox
											name="alwaysRecommended"
											className="me-4"
											checked={formFields.alwaysRecommended}
											label="Always Recommended"
											labelOrientation="right"
											onChange={this.handleCheckbox}
											disabled={isSystemAttribute}
										/>
										<Checkbox
											name="requiredInAlice"
											className="me-4"
											checked={formFields.requiredInAlice}
											label="Required in Alice"
											labelOrientation="right"
											onChange={this.handleCheckbox}
											disabled={isSystemAttribute}
										/>
									</div>
								}
								{
									formFields.required && formFields.readOnly &&
									formFields.attributeType !== "DateTime" && !showAdditionalFields &&
									!formFields.defaultValue && (
										<div className="py-1">
											<ErrorMessage
												valid={false}
												error={"A field cannot be Required and Readonly when default value is blank."}
											/>
										</div>
									)
								}
								<div>
									{formFields.attributeType === "Picklist String" && (
										<div className="border-top mt-4 col-12">
											<div className="form-label d-inline-block" required>
												{t("form.dropdown_values")}
											</div>
											<ErrorMessage visible={errors.isPicklistValid} error={errors.picklistError} />
											<PicklistOptionsField
												key={this.props.SideData._id}
												onChange={this.handleChange}
												value={formFields.picklist}
												onErr={(err) => {
													this.setPicklistError(err);
												}}
											// autoFocus={true}
											/>
										</div>
									)}
								</div>
								<div>
									{formFields.attributeType === "State Field" && (
										<div className="border-top mt-4 col-12">
											<div className="form-label d-inline-block" required>
												{t("form.state_values")}
											</div>
											<ErrorMessage visible={errors.isStatefieldValid} error={errors.statefieldError} />
											<StateFeildOptionsField
												showLanguageTranslation={true}
												key={this.props.SideData._id}
												onChange={this.handleStateFieldChange}
												value={formFields.statefield}
												onErr={(err) => { this.setStateFieldError(err) }}
												showColorPicker={true}
												TooltipPosition={'left'}
												onEditLanguages={(updatedLanguages, index) => {
													const updatedStatefield = [...formFields.statefield];
													updatedStatefield[index].languages = updatedLanguages;
													this.updateForm("statefield", updatedStatefield, true);
												}}
												project={this.props.project}
											/>
											<div className="form-label pt-2">{t("form.state_rules")}</div>
											<Switch
												name="setStatesRules"
												defaultChecked={false}
												onChange={this.handleChange}
												checked={formFields.setStatesRules}
											/>
											{
												formFields.setStatesRules &&
												<>
													<div>
														<button type="button" className="btn p-2 hover-bg-7 hover-border-0 focus-border-0 form-label t-primary pointer" onClick={this.toggleStatesRulesDialog}>
															<i className="me-1 fa fa-edit"></i>{t("form.edit_state_rules")}
														</button>
													</div>
													{showStatesRulesDialog && (
														<StatesRulesDialog
															roles={this.props.roles}
															updateData={this.updateData}
															onClose={this.toggleStatesRulesDialog}
															save={this.updateAttribute}
															formFields={formFields}
															defaultFormFields={this.defaultFormFields}
															attributeId={this.props.SideData._id}
														/>
													)}
												</>
											}
										</div>
									)}
									{
										formFields.attributeType === "Mirror" &&
										formFields.attribute &&
										formFields.attribute.attributeType === "State Field" &&
										(this.props.isInternalUser && this.props.developerMode) &&
										<>
											<div className="form-label pt-2">{t("form.state_rules")}</div>
											<Switch
												name="setStatesRules"
												defaultChecked={false}
												onChange={this.handleChange}
												checked={formFields.setStatesRules}
											/>
											{
												formFields.setStatesRules &&
												<>
													<div>
														<button type="button" className="btn p-2 hover-bg-7 hover-border-0 form-label t-primary pointer" onClick={this.toggleStatesRulesDialog}>
															<i className="me-1 fa fa-edit"></i>{t("form.edit_state_rules")}
														</button>
													</div>
													{showStatesRulesDialog && (
														<StatesRulesDialog
															roles={this.props.roles}
															updateData={this.updateData}
															onClose={this.toggleStatesRulesDialog}
															save={this.updateAttribute}
															formFields={formFields}
															defaultFormFields={this.defaultFormFields}
															attributeId={this.props.SideData._id}
														/>
													)}
												</>
											}
										</>
									}
								</div>
								<div>
									{formFields.attributeType === "Tree Dropdown" && (
										<div className="border-top mt-4 col-12">
											<div className="form-label d-inline-block" required>
												{t("form.tree_dropdown_values")}
											</div>
											<ErrorMessage visible={errors.isTreedropdownValid} error={errors.treedropdownError} />
											<TreeDropdown
												isNew={false}
												onUpdate={this.handleTreeDropdownChange}
												defaultTreeDropdown={formFields.treeDropdown}
											/>
										</div>
									)}
								</div>
								<div>
									{formFields.attributeType === "Mirror" &&
										<MirrorField
											attributes={this.props.attributes}
											disabled={true}
											entityId={this.props.entityId}
											entity={formFields.entity}
											attribute={formFields.attribute}
											relation={formFields.relation}
											onEntityChange={this.handleChange}
											onAttributeChange={this.handleChange}
											onRelationChange={this.handleChange}
										/>
									}
								</div>
								{
									subscription.showCalculatedField && !isSystemAttribute &&
									(
										formFields.attributeType === "Number" ||
										(formFields.attributeType === "DateTime" && formFields.dateTimeType !== "time") ||
										formFields.attributeType === "String"
									) &&
									!this.isAzureAttributeFromUserEntity() &&
									<FormulaDialog
										allAttributes={filteredAttributes}
										entityId={this.props.entityId}
										attributeName={formFields.attributeName}
										attributeType={formFields.attributeType}
										numberType={formFields.numberType}
										formulaStatus={this.formulaStatus}
										getFormula={this.getFormulaDataAttr}
										setFormula={{
											'formula': formFields.formula,
											'formulaJson': formFields.formulaJson,
											'triggerSetting': formFields.triggerSetting
										}}
										resetFlag={this.state.resetFlag}
										disableSwitch={formFields.required || formFields.unique || this.state.isUsedInStartOrEndAttribute}
										parentSaveDisabled={this.state.isAttrLoaded}
									/>
								}
								{showAdditionalFields && (
									<div className="mt-4 border-top">
										{formFields.attributeType === "String" && !isSystemAttribute && (
											<div>
												{(!(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled)) &&
													(
														<>
															<div className="col-12">
																<div className="form-label d-inline-block">
																	{t("form.min_length")}
																</div>
																<ErrorMessage valid={errors.isMinValid} error={errors.minError} />
																<NumericTextBox className="form-control-custom blue-focus" name="min" format="n0" spinners={false} value={formFields.min} disabled={formFields.pattern} onChange={this.handleChange} step={1} />
															</div>
															<div className="col-12">
																<div className="form-label d-inline-block">
																	{t("form.max_length")}
																</div>
																<ErrorMessage valid={errors.isMaxValid} error={errors.maxError} />
																<NumericTextBox className="form-control-custom blue-focus" name="max" format="n0" spinners={false} value={formFields.max} disabled={formFields.pattern} onChange={this.handleChange} step={1} />
															</div>
															<div className="col-12">
																<div className="form-label d-inline-block">
																	{t("form.pattern")}
																	<i title="Pattern input format guide

0 — Requires a digit (0-9).
9 — Requires a digit (0-9) or a space.
# — Requires a digit (0-9), space, plus (+), or minus (-).
L — Requires a letter (a-Z).
? — Requires a letter (a-Z) or a space.
A — Requires an alphanumeric (0-9, a-Z).
a — Requires an alphanumeric (0-9, a-Z) or a space.
& — Requires any character (excluding space).
C — Requires any character or a space.
For example, the mask (000) 000-0000 will format input as (123) 456-7890, where 0 requires a digit in every position, enforcing a strict phone number format.

" class="mx-1 fal fa-info-circle"></i>

																</div>
																<ErrorMessage valid={errors.isPatternValid} error={errors.patternError} />
																<Input name="pattern" value={formFields.pattern} className="form-control form-input" onChange={this.handleChange} />
															</div>
															<div className="form-label d-inline-block col-12">
																{t("form.default_value")}
															</div>
															<ErrorMessage valid={errors.isDefaultValueValid} error={errors.defaultValueError} />
															<MaskedTextBox
																name="defaultValue"
																className="form-control-custom blue-focus"
																mask={formFields.pattern}
																value={formFields.defaultValue}
																onChange={(e) => {
																	this.handleChange(e);
																	this.setState({
																		errors: {
																			isDefaultValueValid: true,
																		},
																	});
																}}
															/>
														</>
													)}

											</div>
										)}
										{formFields.attributeType === "Number" && !isSystemAttribute && (
											<div className="row">
												<div className="col-12">
													<NumberField numberType={formFields.numberType} decimalPlace={formFields.decimalPlace} useThousandSeparator={formFields.useThousandSeparator} unit={formFields.unit} unitSide={formFields.unitSide} onChange={this.handleChange} />
													{(!(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled)) && (
														<>
															<NumberDefaultValueField
																defaultValue={formFields.defaultValue}
																numberType={formFields.numberType}
																errors={errors}
																decimalPlace={formFields.decimalPlace}
																unitSide={formFields.unitSide}
																unit={formFields.unit}
																useThousandSeparator={formFields.useThousandSeparator}
																onChange={this.handleChange}
															/></>)}
												</div>
												{(!(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled)) && (
													<>
														<div className="col-12">
															<div className="form-label d-inline-block">
																{t("form.min_value")}
															</div>
															<ErrorMessage valid={errors.isMinValid} error={errors.minError} />
															<NumericInput disable={formFields.readOnly && formFields.defaultValue > 0} className="form-control" name="min" format={formFields.numberType === "integer" ? "n0" : "n" + formFields.decimalPlace} value={formFields.min} onChange={this.handleChange} maxLength={10} />
														</div>
														<div className="col-12">
															<div className="form-label d-inline-block">
																{t("form.max_value")}
															</div>
															<ErrorMessage valid={errors.isMaxValid} error={errors.maxError} />
															<NumericInput disable={formFields.readOnly && formFields.defaultValue > 0} className="form-control" name="max" format={formFields.numberType === "integer" ? "n0" : "n" + formFields.decimalPlace} value={formFields.max} onChange={this.handleChange} maxLength={10} />
														</div> </>)}
											</div>
										)}
										{
											formFields.attributeType === "Mirror" && formFields.attribute && formFields.attribute.attributeType === "Number" &&
											<div className="row">
												<div className="col-12">
													<NumberField
														numberType={formFields.attribute.numberType}
														decimalPlace={formFields.decimalPlace}
														useThousandSeparator={formFields.useThousandSeparator}
														unit={formFields.unit}
														unitSide={formFields.unitSide}
														onChange={this.handleChange}
													/>
												</div>
											</div>
										}
										{
											formFields.attributeType === "Mirror" &&
											formFields.attribute &&
											formFields.attribute.attributeType === "DateTime" &&
											(
												formFields.attribute.dateTimeType === "time" ||
												formFields.attribute.dateTimeType === "datetime"
											) &&
											<div className="row">
												<div className="col-12">
													<div className="form-label">{t("form.time.interval")}</div>
													<DropDownList
														className="w-100"
														name="interval"
														data={this.interval}
														onChange={this.handleChange}
														value={formFields.interval}
													/>
												</div>
											</div>
										}
										{formFields.attributeType === "Picklist String" && (
											<div className="row">
												<div className="col-12">
													<Checkbox
														disabled={this.defaultFormFields.multiSelect}
														name="multiSelect"
														checked={formFields.multiSelect}
														label={t("form.multiple_selection")}
														labelOrientation="right"
														onChange={this.toggleWarnigDialogForMultiSelect}
													/>
													<i className="fal fa-info-circle ms-1" title="Once multi-select is enabled and saved, you cannot change it back to single-select."></i>
												</div>
												<div className="col-12">
													<div className="form-label">{t("form.default_value")}</div>
													<PicklistDefaultValueField
														onChange={this.handleChange}
														picklist={formFields.picklist}
														value={formFields.defaultValue}
													/>
												</div>
											</div>
										)}
										{(formFields.attributeType === "DateTime" && !isSystemAttribute && (!(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled)) &&
											<div className="row">
												{(formFields.dateTimeType === "date" || formFields.dateTimeType === "datetime") && (
													<div className="col-12 dateTime">
														{errors.defaultDateError && <ErrorMessage valid={errors.isDefaultDateValid} error={errors.defaultDateError} />}
														<div>
															<Checkbox
																onChange={this.handleCheckbox}
																name="setDefaultDate"
																checked={formFields.setDefaultDate}
																label={formFields.dateTimeType === "date" ? t("form.date.default_value") : t("form.date_time.default_value")}
																labelOrientation="right"
																className="dateTimeLabel"
																disabled={this.props.SideData.disableDefaultDateCheckbox}
															/>
														</div>
														<RelativeDateField value={formFields.defaultDate} onChangeSign={this.handleChange} onChangeType={this.handleChange} onChangeValue={this.handleChange} visible={formFields.setDefaultDate} />
													</div>
												)}
												{(formFields.dateTimeType === "time" || formFields.dateTimeType === "datetime") && (
													<>
														{formFields.setDefaultDate && (
															<div className="mt-2 col-12">
																<div className="form-label d-inline-block">
																	{t("form.time.default_value")}
																</div>
																<span className="text-danger ms-2 d-inline-block">{this.state.errors.defaultValueError}</span>
																<TimePickerComponent
																	format={'h:mm aa'}
																	strictMode={true}
																	openOnFocus={true}
																	showClearButton={false}
																	key={this.props.SideData._id}
																	name="defaultTime"
																	value={formFields.defaultTime}
																	change={this.handleTimeFields}
																/>
															</div>
														)}
														{(!(formFields.triggerSetting && JSON.parse(formFields.triggerSetting).formulaEnabled)) && (
															<>
																<div className="mt-1 col-12">
																	<div className="form-label">{t("form.time.interval")}</div>
																	<DropDownList className="w-100" name="interval" data={this.interval} onChange={this.handleChange} value={formFields.interval} />
																</div>
																<div className="mt-2 col-12">
																	<div className="form-label d-inline-block">
																		{t("form.time.earliest_time")}
																	</div>
																	<span className="text-danger ms-2 d-inline-block">{this.state.errors.minError}</span>
																	<TimePickerComponent
																		format={'h:mm aa'}
																		strictMode={true}
																		openOnFocus={true}
																		showClearButton={false}
																		key={this.props.SideData._id}
																		name="minTime"
																		value={formFields.minTime}
																		change={this.handleTimeFields}
																	/>
																</div>
																<div className="mt-2 col-12">
																	<div className="form-label d-inline-block">
																		{t("form.time.latest_time")}
																	</div>
																	<span className="text-danger ms-2 d-inline-block">{this.state.errors.maxError}</span>
																	<TimePickerComponent
																		format={'h:mm aa'}
																		strictMode={true}
																		openOnFocus={true}
																		showClearButton={false}
																		key={this.props.SideData._id}
																		name="maxTime"
																		value={formFields.maxTime}
																		change={this.handleTimeFields}
																	/>
																</div>
															</>)}
													</>
												)}
											</div>
										)}
										{formFields.attributeType === "User Identity" && !isSystemAttribute && (
											<div className="row">
												<div className="col-12">
													<Checkbox name="showProfilePicture" checked={formFields.showProfilePicture} label={t("form.user_identity.show_profile_picture")} labelOrientation="right" onChange={this.handleCheckbox} />
												</div>
												<div className="col-12">
													<Checkbox name="useDisplayName" checked={formFields.useDisplayName} label={t("form.user_identity.use_display_name")} labelOrientation="right" onChange={this.handleCheckbox} />
												</div>
												{!this.props.isUserEntity && (
													<div className="col-12">
														<Checkbox
															name="multiSelect"
															checked={formFields.multiSelect}
															disabled={this.defaultFormFields.multiSelect}
															label="Multiple Selection"
															labelOrientation="right"
															onChange={this.toggleWarnigDialogForMultiSelect}
														/>
														<i className="fal fa-info-circle ms-1" title="Once multi-select is enabled and saved, you cannot change it back to single-select."></i>
													</div>
												)}
												<div className="col-12">
													<div className="form-label">{t("form.user_identity.default_value")}</div>
													<ComboBox className="form-control-custom" name="defaultValue" data={["Current User"]} value={formFields.defaultValue} onChange={this.handleChange} />
												</div>
											</div>
										)}
										{formFields.attributeType === "Boolean" && (
											<div className="row">
												<div className="col-12">
													<div className="form-label">{t("form.default_value")}</div>
													<BooleanDefaultValueField value={formFields.defaultValue} onChange={this.handleChange} />
												</div>
											</div>
										)}
										{formFields.attributeType === "Entity Lookup" && (
											<>
												{
													this.state.lookupAttributeError ?
														<div className="row">
															<div className="col-12 my-2">
																<ErrorMessage valid={false} error={this.state.lookupAttributeError} />
															</div>
														</div>
														:
														<div className="row">
															<div className="col-12">
																<div className="form-label">{t("form.entity_lookup.target_entity")}</div>
																<DropDownList className="w-100 form-control-custom" disabled value={formFields.referenceEntity} textField="name" />
															</div>
															<div className="col-12">
																<div className="form-label">{t("form.entity_lookup.target_property")}</div>
																<DropDownList className="w-100 form-control-custom" disabled value={formFields.referencedAttribute} textField="attributeName" />
															</div>
														</div>
												}
											</>
										)}
										{
											formFields.attributeType === "Image" && (
												<div className="row">
													<div className="col-12">
														<div className="form-label">
															{t("form.image.file_type")}
														</div>
														<MultiSelect
															data={this.allowedFileTypes}
															value={formFields.allowedFileTypes}
															name="allowedFileTypes"
															onChange={this.handleChange}
														/>
														<ErrorMessage
															valid={this.state.errors.isAllowedFileTypesValid}
															error={this.state.errors.allowedFileTypesError}
														/>
													</div>
													<div className="col-12">
														<div className="form-label">
															{t("form.image.number_of_attachments")}
														</div>
														<NumericTextBox
															className="form-control-custom"
															value={formFields.maxNumberOfImages}
															onChange={this.handleChange}
															name="maxNumberOfImages"
															min={1}
															max={30}
															format="n0"
														/>
														<ErrorMessage
															valid={this.state.errors.isNumberOfAttachmentsValid}
															error={this.state.errors.numberOfAttachmentsError}
														/>
													</div>
													<div className="col-12">
														<div className="form-label">
															{t("form.image.maximum_size")}
														</div>
														<NumericTextBox
															className="form-control-custom"
															value={formFields.maxFileSize}
															onChange={this.handleChange}
															name="maxFileSize"
															min={1}
															max={10}
															format="n0"
														/>
													</div>
												</div>
											)
										}

										{formFields.attributeType !== "String" &&
											formFields.attributeType !== "State Field" &&
											formFields.attributeType !== "Number" &&
											formFields.attributeType !== "Picklist String" &&
											formFields.attributeType !== "DateTime" &&
											formFields.attributeType !== "User Identity" &&
											formFields.attributeType !== "Boolean" &&
											formFields.attributeType !== "Tags" &&
											formFields.attributeType !== "Mirror" &&
											formFields.attributeType !== "Entity Lookup" &&
											formFields.attributeType !== "Shared Lookup" &&
											formFields.attributeType !== "Image" && (
												<div className="row border-bottom pb-4">
													<div className="col-12">
														<div className="form-label d-inline-block">
															{t("form.default_value")}
														</div>
														<ErrorMessage valid={errors.isDefaultValueValid} error={errors.defaultValueError} />
														<Input className="form-control form-input" name="defaultValue" value={formFields.defaultValue} onChange={this.handleChange} />
													</div>
												</div>
											)}
										<div className="row">
											<div className="mt-1 col-12">
												{
													(
														formFields.attributeType === "Number" ||
														formFields.attributeType === "Picklist String" ||
														(
															formFields.attributeType === "Mirror" &&
															formFields.attribute &&
															(
																formFields.attribute.attributeType === "Number" ||
																formFields.attribute.attributeType === "Picklist String"
															)
														)
													) &&
													<>
														<div className="form-label d-inline-block mb-4">
															{t("form.color_formatting")}
														</div>
														<CellFormating
															attribute={formFields}
															updateAttribute={this.updateForm}
														/>
													</>

												}
											</div>
										</div>
										<div className="row">
											<div className="mt-1 col-12">
												<div className="form-label">{t("form.tooltip")}</div>
												<input disabled={isSystemAttribute} className="form-control" name="tooltip" value={formFields.tooltip} onChange={this.handleChange} />
											</div>
											<div className="col-12">
												<div className="form-label">{t("form.description")}</div>
												<textarea disabled={isSystemAttribute} className="form-control" name="description" onChange={this.handleChange} value={formFields.description}></textarea>
											</div>
											{/* {
												(this.props.developerMode) &&
												(
													formFields.attributeType === "String" ||
													formFields.attributeType === "URL" ||
													formFields.attributeType === "Email" ||
													formFields.attributeType === "Multiline Text" ||
													formFields.attributeType === "Html"
												) &&
												<div className="col-12">
													<div className="form-label">{t("form.dummy_label")}</div>
													<DropDownList
														className="form-control-custom"
														name="dummyLabel"
														key={formFields.attributeType}
														data={this.filterDummyData(formFields.attributeType)}
														value={formFields.dummyLabel}
														onChange={this.handleChange}
													/>
												</div>
											} */}
										</div>
									</div>
								)}
							</div>
							{
								!this.isAzureAttributeFromUserEntity() &&
								<ShowMore toggled={(o) => this.toggleFields(o)} more={this.state.showAdditionalFields}></ShowMore>
							}
						</Scrollable>}
				</div >
			</div >
		);
	}

	getMirrorSubType = () => {
		if (this.state.formFields.attribute) {
			const { attribute } = this.state.formFields;
			return attribute.attributeType;
		}
	}

	getFormulaDataAttr = async (value) => {
		var { formula, saveAsTemplate, disabled, triggerSetting } = this.state;
		formula = value;
		saveAsTemplate = value.formula.length > 0;
		let dataTrigger = value.triggerSetting;
		triggerSetting = dataTrigger;
		let oldDisValue = disabled;
		this.updateForm('formula', value.formula && value.formula.length > 0 ? value.formula : "");
		this.updateForm('formulaJson', value.formulaJson ? JSON.stringify(value.formulaJson) : "");
		this.updateForm('triggerSetting', dataTrigger ? JSON.stringify(dataTrigger) : "");
		await this.updateFormula(dataTrigger, value.formula, value.formulaJson);
		disabled = oldDisValue;
		this.setState({ formula, saveAsTemplate, triggerSetting, disabled });
		this.updateAttribute();
	}

	updateFormula = async (triggerSetting, formula, formulaJson) => {
		const { entityId, SideData, loadAttribute } = this.props;

		triggerSetting["formulaEnabled"] = true;

		await updateAttributeFormula({
			entityId,
			formula,
			formulaJson,
			triggerSetting,
			attributeId: SideData._id
		})

		loadAttribute();
	}

	formulaStatus = (formulaEnabled) => {
		var { triggerSetting, formula, formFields } = this.state;
		let formFieldsTriggerSetting = this.state.formFields.triggerSetting;
		if (Object.keys(triggerSetting).length === 0 && (typeof formFieldsTriggerSetting === "string")) {
			triggerSetting = JSON.parse(formFieldsTriggerSetting);
		}
		triggerSetting["formulaEnabled"] = formulaEnabled;
		const defaultTriggerSettings = this.defaultFormFields.triggerSetting ? JSON.parse(this.defaultFormFields.triggerSetting) : { formulaEnabled: false };
		// For disable only formula enabled is checked and readOnly is not checked
		// Because in read-only checkbox there triggerSetting.formulaEnabled is used
		// to determine check state of readonly when formula is there
		// also done to fix #8619
		const disabled = (
			triggerSetting.formulaEnabled === defaultTriggerSettings.formulaEnabled ||
			!formFields.formulaJson
		);
		const newFormFields = {
			...formFields,
			triggerSetting: JSON.stringify(triggerSetting),
			readOnly: formulaEnabled
		}
		const errors = this.validate(newFormFields);
		this.setState({
			formFields: newFormFields,
			disabled,
			errors,
			triggerSetting
		})
		// if (!val) {
		// this.updateForm('readOnly', val, this.defaultFormFields['readOnly']);
		// }
		// this.updateForm('triggerSetting', triggerSetting ? JSON.stringify(triggerSetting) : "");
		// if (val) {
		// 	this.updateForm('readOnly', val, this.defaultFormFields['readOnly']);
		// }
		// this.setState({ triggerSetting });
	}

	componentDidMount() {
		if (this.props.mutators) {
			this.props.mutators.setFormSaveFunction(() => this.updateAttribute);
		}
	}

	isLanguagesChanged(languages, defaultLanguages, property="label") {
		const keys = Object.keys(languages);
		for (const key of keys) {
			if (
				languages[key][property] !== defaultLanguages[key][property]
			) {
				return true;
			}
		}
		return false;
	}

	async componentDidUpdate(props, state) {
		// If the selected attribute changes
		if (this.props.SideData._id !== props.SideData._id) {
			this.setState({ isAttrLoaded: false });
			const formFields = await this.getFormFields();
			const isUsedInStartOrEndAttribute = await this.getIsUsedInStartOrEndAttribute();
			const groups = this.getGroups();
			const showAdditionalFields = this.getShowMoreValueById(this.props.entityId, this.props.SideData._id);
			const errors = {};
			const disabled = true;
			this.addRecommendationFieldIfApplicable(formFields);
			this.addUserProfileRelatedFieldsIfApplicable(formFields);
			this.defaultFormFields = { ...formFields };
			this.setState({
				formFields,
				groups,
				errors,
				disabled,
				showAdditionalFields,
				isUsedInStartOrEndAttribute,
				isAttrLoaded: true
			});
		} else if (
			typeof this.props.SideData.sharedLookupId === "string" &&
			this.props.SideData._id === props.SideData._id &&
			(
				this.props.SideData.attributeName !== props.SideData.attributeName ||
				this.isLanguagesChanged(this.props.SideData.languages, props.SideData.languages, "name")
			)
		) {
			const formFields = this.state.formFields;
			formFields.attributeName = this.props.SideData.attributeName;
			formFields.attributeLabel = this.props.SideData.attributeLabel;
			formFields.tooltip = this.props.SideData.tooltip;
			formFields.languages = this.props.SideData.languages
			this.setState({
				formFields
			});
		}

		if (this.state.disabled !== state.disabled) {
			if (this.props.mutators) {
				this.props.mutators.setFormsWithChanges(prevValue => ({
					...prevValue,
					attributeForm: state.disabled
				}));
			}
		}
	}

	addRecommendationFieldIfApplicable = (formFields) => {
		if (this.isLibrary && this.props.isInternalUser) {
			formFields.alwaysRecommended = this.props.SideData.alwaysRecommended;
			formFields.requiredInAlice = this.props.SideData.requiredInAlice;
		}
	}

	addUserProfileRelatedFieldsIfApplicable = (formFields) => {
		if (this.props.isUserEntity) {
			formFields.isAzureAttribute = this.props.SideData.isAzureAttribute;
		}
	}

	getFormFields = async () => {
		const { SideData } = this.props;
		const { attributeType } = SideData;
		const formFields = {};
		const fieldsForAttributeType = Fields[attributeType] || Fields["Base"];
		for (let fieldData of fieldsForAttributeType) {
			const { field, state, type } = fieldData;
			const initialValue = SideData[field];
			let value = initialValue;
			formFields[state] = value;
		}
		if (this.isEntityLookup()) {
			const { referenceEntity, referencedAttribute } = await this.getLookupProperties();
			if (referenceEntity && referencedAttribute) {
				formFields.referenceEntity = referenceEntity;
				formFields.referencedAttribute = referencedAttribute;
			} else {
				this.setState({
					lookupAttributeError: this.props.t("errors.cannot_fetch_reference_attribute")
				})
			}
		} else if (attributeType === "Number") {
			formFields.unit = formFields.unit.replace(/\\\"/, '"');
		} else if (attributeType === "Tree Dropdown") {
			if (typeof (formFields.treeDropdown) === "string") {
				formFields.treeDropdown = JSON.parse(formFields.treeDropdown);
			}
		} else if (attributeType === "Mirror") {
			formFields.attribute = SideData.attribute;
			formFields.entity = SideData.entity;
			formFields.relation = SideData.relation;
			formFields.relationId = SideData.relationId;
			if (formFields.attribute) {
				this.setTargetAttributeDependentProperties(formFields, SideData);
			}
		}
		if (attributeType === "Shared Lookup") {
			formFields.sharedLookupType = SideData.sharedLookupType;
		}
		return formFields;
	};

	getIsUsedInStartOrEndAttribute = async () => {
		const { _id, attributeType } = this.props.SideData;
		if (attributeType === "DateTime") {
			const response = await getIsStartOrEndAttributeInGanttChart(_id);
			return response.isStartOrEndAttribute;
		}
		return false;
	}

	setTargetAttributeDependentProperties = (formFields, sideData) => {
		const { attribute } = formFields;
		switch (attribute.attributeType) {
			case "Number":
				formFields.unit = sideData.unit;
				formFields.unitSide = sideData.unitSide;
				formFields.useThousandSeparator = sideData.useThousandSeparator;
				break;
			case "Picklist String":
				formFields.picklist = formFields.attribute.picklist;
				break;
			case "DateTime":
				if (attribute.dateTimeType === "datetime" || attribute.dateTimeType === "time") {
					formFields['interval'] = sideData['interval'] || "30";
				}
				break;
			default:
				break;
		}
	}

	isEntityLookup = () => {
		const { SideData } = this.props;
		const { attributeType } = SideData;
		return attributeType === "Entity Lookup";
	};

	isImageAttribute = () => {
		const { SideData } = this.props;
		const { attributeType } = SideData;
		return attributeType === "Image";
	};

	isUserEntityEmail = () => {
		const { SideData } = this.props;
		const { attributeName } = SideData;
		return attributeName === "Email" && this.props.isUserEntity;
	};

	showReadOnly = () => {
		const { formFields } = this.state
		if (this.isUserEntityEmail()) {
			return true;
		}
		if (formFields.attributeType === "Picklist String" || formFields.attributeType === "Tree Dropdown" || formFields.attributeType === "State Field" || formFields.attributeType === "Shared Lookup") {
			return false
		}
		return (
			!(this.isAzureAttributeFromUserEntity() && this.isUserEntityEmail()) &&
			!this.isImageAttribute()
		);
	}

	getGroups = () => {
		const { attributes } = this.props;
		const allAttributesGroups = attributes.map((attr) => attr.group).filter((group) => group && group.trim());
		const groups = [...new Set(allAttributesGroups)];
		return groups;
	};

	hasErrors = (e) => {
		let errors = !this.state.disabled
		if (
			this.state.errors.isNameValid === false ||
			this.state.errors.isMinValid === false ||
			this.state.errors.isMaxValid === false ||
			this.state.errors.isDefaultValueValid === false ||
			this.state.errors.isDefaultDateValid === false ||
			this.state.errors.isPicklistValid === false ||
			this.state.errors.isStatefieldValid === false ||
			this.state.errors.isTreedropdownValid === false ||
			this.state.errors.isPatternValid === false ||
			this.state.errors.isLabelValid === false
		) {
			errors = true
		}
		return errors
	}

	getLookupProperties = async () => {
		const { _id } = this.props.SideData;
		const response = await getEntityLookupReferencedAttribute(_id);
		const { message } = response;
		if (message === "Reference attribute found") {
			const { referenceEntity, referencedAttribute } = response.data;
			return {
				referenceEntity,
				referencedAttribute,
			};
		} else {
			//
		}
	};

	getShowMoreValueById = (entityId, attributeId) => {
		const entityConfigLocalStorageString = localStorage.getItem("entity-config");
		if (entityConfigLocalStorageString === null) {
			return false;
		}
		const entityConfig = JSON.parse(entityConfigLocalStorageString);
		if (entityConfig[entityId] === undefined) {
			return false;
		}
		if (entityConfig[entityId][attributeId] === undefined) {
			return false;
		}
		return entityConfig[entityId][attributeId]["showMoreAttributeProperties"];
	};

	// Render functions
	shouldSaveAsAttributeTemplateBeDisabled = () => (
		!this.state.disabled || this.props.SideData.isSystemAttribute || this.props.SideData.attributeType === "Entity Lookup" || ((this.state.formFields.triggerSetting && JSON.parse(this.state.formFields.triggerSetting).formulaEnabled) && (this.state.formFields.formula != undefined && this.state.formFields.formula.length > 0))
	)

	shouldDeleteBeDisabled = () => {
		return (
			this.props.SideData.isSystemAttribute ||
			this.isAzureAttributeFromUserEntity()
		);
	}

	isAzureAttributeFromUserEntity = () => {
		return this.props.isUserEntity && this.state.formFields.isAzureAttribute
	}

	// handlers

	toggleStatesRulesDialog = () => {
		this.setState({ showStatesRulesDialog: !this.state.showStatesRulesDialog });
	};

	filterDummyData = (attributeType) => {
		if (attributeType === "String") {
			return DummyLabelHelper.DummyLabelValues
		} else {
			let filterValue = DummyLabelHelper.TypeMap.find(type => type.type === attributeType).value
			let dummyLabeldData = DummyLabelHelper.DummyLabelValues.filter(label => label === filterValue || label === "No Match")
			return dummyLabeldData
		}
	}

	handleChangeWithName = (name, value) => {
		this.updateForm(name, value);
	};

	// handleChangeWithoutValidation = (e) => {
	// 	const { name, value } = e.target;
	// 	this.updateForm(name, value, true);
	// };

	handleGroupChange = (e) => {
		const { name } = e.target;
		let { value } = e.target;
		if (value === null) {
			value = '';
		}
		this.updateForm(name, value);
	}

	handleStateFieldChange = (data) => {
		this.updateForm("statefield", data);
	};

	handleTreeDropdownChange = (data) => {
		this.updateForm("treeDropdown", data);
	};

	handleChange = (e) => {
		let { name, value } = e.target;
		if (value === null && (name === 'min' || name === 'max')) {
			this.updateForm(name, "");
		} else {
			this.updateForm(name, value);
		}
	};

	handleCheckbox = (e) => {
		const { name } = e.target.element;
		const { value } = e;
		this.updateForm(name, value);
	};

	setLabelTranslation = (data) => {
		this.updateForm("languages", data);
		this.setState({
			showLabelTranslationDialog: false
		});
	}

	handleTimeFields = (e) => {
		if (e.event === null) return;
		const { text } = e;
		const { name } = e.element;
		this.updateForm(name, text);
	};

	clearTimeField = (name) => {
		this.updateForm(name, "");
	};

	updateData = (type, data) => {
		this.defaultFormFields[type] = data;
		this.updateForm(type, data)
	};
	updateForm = (property, value, validate = true) => {
		debugger;
		const { formFields } = this.state;
		formFields[property] = value;
		this.setDependentProperties(formFields, property);
		if (validate) {
			const errors = this.validate(formFields);
			const disabled = property === 'formula' || property === 'formulaJson' ? false : this.disableSave(formFields, errors);
			// const disabled =  this.disableSave(formFields, errors);
			this.setState({ formFields, disabled, errors });
		} else {
			this.setState({ formFields });
		}
	};

	setDependentProperties = (formFields, property) => {
		if (property === "defaultDate") {
			if (formFields[property]) {
				// control the null value
				formFields.defaultDate = formFields.defaultDate.replace("__", "_0_")
			}
		}
		if (property === "setDefaultDate" && formFields.attributeType === "DateTime") {
			formFields.defaultDate = "Today_+_0_Days";
			formFields.defaultTime = "10:00 AM";
		} else if (property === "unit" && formFields[property].trim() === "") {
			formFields["unit"] = "none";
			formFields["unitSide"] = this.defaultFormFields.unitSide || "Right";
		} else if (property === "picklist") {
			let dropdownValues = formFields.picklist.split('ɖ')
			let exist = dropdownValues.includes(formFields.defaultValue)
			if (!exist) {
				formFields.defaultValue = ""
			}
		} else if ((property === "readOnly" || property === "defaultValue") && formFields.readOnly && formFields.defaultValue !== "" && formFields.attributeType === "Number") {
			formFields.min = ""
			formFields.max = ""
		} else if (property === "entity") {
			formFields.relation = {};
			formFields.attribute = {};
		} else if (property === "relation") {
			formFields.attribute = {};
		} else if (formFields.attributeType === "Picklist String" && property === "defaultValue") {
			if (formFields.defaultValue === null || formFields.defaultValue === undefined) {
				formFields.defaultValue = ""
			}
		}
	};

	// Change detection
	disableSave = (formFields, errors) => {
		const errorKeys = Object.keys(errors).filter((key) => key.startsWith("is"));
		for (const key of errorKeys) {
			if (!errors[key]) {
				return true;
			}
		}
		const { defaultFormFields } = this;
		const { attributeType } = formFields;
		const fieldData = [...Fields[attributeType]];
		if (attributeType === "Mirror") {
			if (
				formFields.attribute &&
				(
					formFields.attribute.attributeType === "Number" ||
					formFields.attribute.attributeType === "DateTime" ||
					formFields.attribute.attributeType === "Picklist String" ||
					formFields.attribute.attributeType === "State Field"
				)
			) {
				let otherFieldsArr = Fields[formFields.attribute.attributeType];
				for (let fieldElement of otherFieldsArr) {
					const { field } = fieldElement;
					const isIncluded = fieldData.some((fieldDataElement) => fieldDataElement.field === field)
					if (!isIncluded) {
						fieldData.push(fieldElement)
					}
				}
			}
		}
		let isChanged = true;
		for (const field of fieldData) {
			if (field.state === "formula" || field.state === "formulaJson") {
				continue;
			}
			if (field.state === "triggerSetting") {
				if (formFields.formula === undefined) {
					isChanged = true;
					continue;
				}
				let formFieldsTriggerSetting = formFields[field.state];
				if (defaultFormFields[field.state] === undefined) {
					if (typeof formFieldsTriggerSetting === "string") {
						formFieldsTriggerSetting = JSON.parse(formFieldsTriggerSetting);
						if (formFieldsTriggerSetting.formulaEnabled === true) {
							isChanged = true;
							continue;
						}
					}
				}
				let defaultFormFieldsTriggerSetting = defaultFormFields[field.state];
				if (typeof defaultFormFieldsTriggerSetting === "string" && typeof formFieldsTriggerSetting === "string") {
					defaultFormFieldsTriggerSetting = JSON.parse(defaultFormFieldsTriggerSetting);
					formFieldsTriggerSetting = JSON.parse(formFieldsTriggerSetting);
					if (defaultFormFieldsTriggerSetting.formulaEnabled !== formFieldsTriggerSetting.formulaEnabled) {
						isChanged = true;
						continue;
					}
				}
			}
			// check for name and color change in statefield for each items
			if (field.state === "statefield" && attributeType === "State Field") {
				if (formFields.statefield.length !== defaultFormFields.statefield.length) {
					isChanged = false;
					break;
				}
				for (let i = 0; i < formFields.statefield.length; i++) {
					if (
						formFields.statefield[i].name !== defaultFormFields.statefield[i].name ||
						formFields.statefield[i].color.replace(/\s/g, '') !== defaultFormFields.statefield[i].color.replace(/\s/g, '')
					) {
						isChanged = false;
						break;
					}
					const newLanguages = formFields.statefield[i].languages;
					const defaultLanguages = defaultFormFields.statefield[i].languages;
					if (this.isLanguagesChanged(newLanguages, defaultLanguages, "name")) {
						isChanged = false;
						break;
					}
				}
				if (!isChanged) break;
				continue;
			}
			if (field.state === "cellFormatting") {
				const isCellFormattingChanged = this.checkCellFormattingHasChanged(formFields[field.state], defaultFormFields[field.state]);
				if (isCellFormattingChanged) {
					isChanged = false;
					break;
				}
				continue;
			}
			if (field.state === "treeDropdown") {
				const isSame = CheckIfTreeIsSame(formFields[field.state], defaultFormFields[field.state]);
				if (!isSame) {
					isChanged = false;
					break;
				}
				continue;
			}
			if (field.state === "allowedFileTypes") {
				if (formFields.allowedFileTypes.length !== defaultFormFields.allowedFileTypes.length) {
					isChanged = false;
					break;
				}
				for (let i = 0; i < formFields.allowedFileTypes.length; i++) {
					if (formFields.allowedFileTypes[i] !== defaultFormFields.allowedFileTypes[i]) {
						isChanged = false;
						break;
					}
				}
				if (!isChanged) break;
				continue;
			}
			if (field.state === "attribute" || field.state === "entity" || field.state === "relation") {
				if (!formFields[field.state] && defaultFormFields[field.state]) {
					isChanged = true;
					break;
				}
				if (
					(formFields[field.state] && !defaultFormFields[field.state]) ||
					(formFields[field.state] && defaultFormFields[field.state] && formFields[field.state]._id !== defaultFormFields[field.state]._id)
				) {
					isChanged = false;
					break;
				}
				continue;
			}
			if ((defaultFormFields[field.state] !== formFields[field.state])) {
				isChanged = false;
				break;
			}
		}

		if (this.isLibrary && this.props.isInternalUser) {
			if (
				formFields.alwaysRecommended !== defaultFormFields.alwaysRecommended ||
				formFields.requiredInAlice !== defaultFormFields.requiredInAlice
			) {
				isChanged = false;
			}
		}
		return isChanged;
	};

	checkCellFormattingHasChanged = (cellFormatting, defaultCellFormatting) => {
		if (typeof cellFormatting !== "object") {
			cellFormatting = JSON.parse(cellFormatting);
		}
		if (typeof defaultCellFormatting !== "object") {
			defaultCellFormatting = JSON.parse(defaultCellFormatting);
		}
		const { ifStatement, elseStatement } = cellFormatting
		const { ifStatement: defaultIfStatement, elseStatement: defaultElseStatement } = defaultCellFormatting
		if (ifStatement.length !== defaultIfStatement.length || elseStatement.length !== defaultElseStatement.length) {
			return true;
		}
		for (let i = 0; i < ifStatement.length; i++) {
			if (
				typeof ifStatement[i].condition1 !== typeof defaultIfStatement[i].condition1 ||
				typeof ifStatement[i].condition2 !== typeof defaultIfStatement[i].condition2
			) {
				return true;
			}
			if (typeof ifStatement[i].condition1 === "object") {
				if (ifStatement[i].condition1.length !== defaultIfStatement[i].condition1.length) {
					return true;
				}
				for (let j = 0; j < ifStatement[i].condition1.length; j++) {
					if (ifStatement[i].condition1[j] !== defaultIfStatement[i].condition1[j]) {
						return true;
					}
				}
			}
			if (
				ifStatement[i].condition1 !== defaultIfStatement[i].condition1 ||
				ifStatement[i].condition2 !== defaultIfStatement[i].condition2 ||
				ifStatement[i].color !== defaultIfStatement[i].color ||
				ifStatement[i].colorOption.value !== defaultIfStatement[i].colorOption.value ||
				ifStatement[i].operator.value !== defaultIfStatement[i].operator.value
			) {
				return true;
			}
		}
		for (let i = 0; i < elseStatement.length; i++) {
			if (
				elseStatement[i].color !== defaultElseStatement[i].color ||
				elseStatement[i].colorOption.value !== defaultElseStatement[i].colorOption.value
			) {
				return true;
			}
		}
		return false;
	}

	// Validation
	validate = (formFields) => {
		const { attributes } = this.props;
		const { _id } = this.props.SideData;
		const errors = {
			isNameValid: true,
			isLabelValid: true,
			isMinValid: true,
			isMaxValid: true,
			isDefaultValueValid: true,
			isDefaultDateValid: true,
			isPicklistValid: true,
			isStatefieldValid: true,
			isTreedropdownValid: true,
			isPatternValid: true,
			isNumberOfAttachmentsValid: true,
			isMaxFileSizeValid: true,
			isAllowedFileTypesValid: true,
			nameError: "",
			labelError: "",
			minError: "",
			maxError: "",
			defaultValueError: "",
			defaultDateError: "",
			picklistError: "",
			treedropdownError: "",
			statefieldError: "",
			patternError: "",
			numberOfAttachmentsError: "",
			maxFileSizeError: "",
			allowedFileTypesError: ""
		};

		if (!formFields.attributeName.trim()) {
			errors.isNameValid = false;
			errors.nameError = this.props.t("errors.name_is_required");
		} else if (formFields.attributeName.trim().match(/^\d/)) {
			errors.isNameValid = false;
			errors.nameError = this.props.t("errors.name_cannot_start_with_number");
		} else if (/^\[SYS\]/i.test(formFields.attributeName.trim())) {
			errors.isNameValid = false;
			errors.nameError = this.props.t("errors.name_cannot_have_sys_prefix");
		} else if (formFields.attributeName.trim().length > 30) {
			errors.isNameValid = false;
			errors.nameError = this.props.t("errors.name_length_exceeded");
		} else if (formFields.attributeName.toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim() === "id") {
			errors.isNameValid = false;
			errors.nameError = this.props.t("errors.name_is_reserved")
		} else {
			const nameInUse = attributes.find((attr) => (
				removeSpecialCharacters(attr.attributeName.toLowerCase().trim()) === removeSpecialCharacters(formFields.attributeName.toLowerCase().trim()) &&
				attr._id !== _id
			));
			if (nameInUse) {
				errors.isNameValid = false;
				errors.nameError = this.props.t("errors.name_in_use");
			}
		}
		if (formFields.attributeLabel.trim() === "") {
			errors.isLabelValid = false
			errors.labelError = this.props.t("errors.label_required");
		}

		if (formFields.required && formFields.readOnly && formFields.defaultValue === "") {
			errors.isDefaultValueValid = false;
			errors.defaultValueError = this.props.t("errors.default_value_required");
		}

		if (formFields.attributeType === "String") {
			const { min, max, pattern, defaultValue } = formFields;
			const patternRegex = /^[\?\s09\#LAa\&()C-]+$/g;

			if (pattern && !patternRegex.test(pattern)) {
				errors.isPatternValid = false;
				errors.patternError = this.props.t("errors.invalid_pattern_characters")
			}

			const minValue = parseInt(min);
			const maxValue = parseInt(max);
			const defaultValueLength = defaultValue ? defaultValue.length : 0;

			if (errors.isMinValid && minValue < 1) {
				errors.isMinValid = false;
				errors.minError = this.props.t("errors.min_length_must_be_greater_than_0");
			}

			if (errors.isMaxValid && maxValue < 1) {
				errors.isMaxValid = false;
				errors.maxError = this.props.t("errors.max_length_must_be_greater_than_0");
			}

			if (errors.isMaxValid && maxValue > 256) {
				errors.isMaxValid = false;
				errors.maxError = this.props.t("errors.maximum_length_cannot_exceed_256");
			}

			if (errors.isMaxValid && errors.isMinValid && minValue > maxValue) {
				errors.isMinValid = false;
				errors.minError = this.props.t("errors.minimum_length_cannot_exceed_maximum_length");
			}

			if (errors.isMinValid && defaultValueLength > 0 && minValue > defaultValueLength && !pattern) {
				errors.isDefaultValueValid = false;
				errors.defaultValueError = this.props.t("errors.default_value_cannot_below_min_length");
			}
			if (errors.isMaxValid && defaultValueLength > 0 && maxValue < defaultValueLength && !pattern) {
				errors.isDefaultValueValid = false;
				errors.defaultValueError = this.props.t("errors.default_value_cannot_exceed_max_length");
			}
			if (errors.isPatternValid && errors.isDefaultValueValid && defaultValueLength > 0) {
				const { KendoMaskToRegexMap } = this;
				let patternRegexString = "";
				for (let letter of pattern) {
					patternRegexString += KendoMaskToRegexMap[letter] || letter;
				}
				const patternRegex = new RegExp(patternRegexString);
				if (!patternRegex.test(defaultValue)) {
					errors.isDefaultValueValid = false;
					errors.defaultValueError = this.props.t("errors.default_value_must_match_pattern");
				}
			}
		} else if (formFields.attributeType === "Picklist String") {
			const picklistValues = formFields.picklist
				.split("ɖ")
				.filter((option) => option.trim() !== "")
				.map((option) => option.trim());
			const picklistValuesMap = {};

			let isPicklistValid = true;

			if (picklistValues.length === 0) {
				errors.isPicklistValid = false;
				errors.picklistError = this.props.t("errors.dropdown_values_is_required");
			}
			else {
				for (const value of picklistValues) {
					picklistValuesMap[value] = picklistValuesMap[value] ? ++picklistValuesMap[value] : 1;
					if (picklistValuesMap[value] > 1) {
						isPicklistValid = false;
						break;
					}
				}
				if (!isPicklistValid) {
					errors.isPicklistValid = isPicklistValid;
					errors.picklistError = this.props.t("errors.duplicate_values_not_allowed");
				}
			}
		} else if (formFields.attributeType === "State Field") {
			const statefieldValues = formFields.statefield
				.filter((option) => option.name.trim() !== "")
				.map((option) => option.name.trim());
			const statefieldValuesMap = {};

			let isStatefieldValid = true;

			if (statefieldValues.length === 0) {
				errors.isStatefieldValid = false;
				errors.statefieldError = this.props.t("errors.dropdown_values_is_required")
			}
			else {
				for (const value of statefieldValues) {
					statefieldValuesMap[value] = statefieldValuesMap[value] ? ++statefieldValuesMap[value] : 1;
					if (statefieldValuesMap[value] > 1) {
						isStatefieldValid = false;
						break;
					}
				}
				if (!isStatefieldValid) {
					errors.isStatefieldValid = isStatefieldValid;
					errors.statefieldError = this.props.t("errors.duplicate_values_not_allowed");
				}
			}
		} else if (formFields.attributeType === "DateTime") {
			if (formFields.dateTimeType === "time" || formFields.dateTimeType === "datetime") {
				const { minTime, maxTime, defaultTime } = formFields;
				let min = minTime;
				let max = maxTime;
				let DefaultTime = defaultTime
				if (min !== "") {
					min = new Date('2020-01-01 ' + minTime);
				}
				if (max !== "") {
					max = new Date('2020-01-01 ' + maxTime);
				}
				if (defaultTime !== "") {
					DefaultTime = new Date('2020-01-01 ' + defaultTime)
				}

				if (min && max && min > max) {
					errors.isMinValid = false;
					errors.minError = this.props.t("errors.earliest_time_cannot_exceed_latest_time");
				} else {
					errors.isMinValid = true;
					errors.minError = "";
				}

				if (DefaultTime === "" && formFields.dateTimeType === "datetime" && formFields.setDefaultDate) {
					errors.isDefaultValueValid = false;
					errors.defaultValueError = this.props.t("errors.default_time_cannot_be_blank");
				} else if (DefaultTime && min && DefaultTime < min && formFields.setDefaultDate) {
					errors.isDefaultValueValid = false;
					errors.defaultValueError = this.props.t("errors.default_time_cannot_exceed_earliest_time");
				} else if (DefaultTime && max && DefaultTime > max && formFields.setDefaultDate) {
					errors.isDefaultValueValid = false;
					errors.defaultValueError = this.props.t("errors.default_time_cannot_be_later_than_latest_time");
				} else {
					errors.isDefaultValueValid = true;
					errors.defaultValueError = "";
				}
			}
			if (formFields.setDefaultDate && (formFields.dateTimeType === "date" || formFields.dateTimeType === "datetime")) {
				const { defaultDate } = formFields;
				const defaultDateValue = defaultDate.split("_");
				const defaultDateDayDifference = defaultDateValue[2];
				if (parseInt(defaultDateDayDifference) > 365) {
					errors.isDefaultDateValid = false;
					errors.defaultDateError = this.props.t("errors.difference_must_be_less_than_365");
				}
			}
		} else if (formFields.attributeType === "Number") {
			let { min, max, defaultValue } = formFields;
			const minValue = parseInt(min);
			const maxValue = parseInt(max);
			defaultValue = defaultValue === null ? "" : defaultValue;
			const defaultValueLength = defaultValue === "" ? 0 : defaultValue.toString().length;
			if (minValue > 2147483647) {
				errors.isMinValid = false;
				errors.minError = this.props.t("errors.min_value_cannot_exceed_limit");
			}
			if (maxValue > 2147483647) {
				errors.isMaxValid = false;
				errors.maxError = this.props.t("errors.max_value_cannot_exceed_limit");
			}
			if (defaultValueLength > 0 && parseInt(defaultValue) > 2147483647) {
				errors.isDefaultValueValid = false;
				errors.defaultValueError = this.props.t("errors.default_value_cannot_exceed_limit");
			}

			if (errors.isMaxValid && errors.isMinValid && minValue > maxValue) {
				errors.isMinValid = false;
				errors.minError = this.props.t("errors.min_value_cannot_exceed_max_value");
			}

			if (errors.isMinValid && minValue > defaultValue && defaultValueLength > 0) {
				errors.isDefaultValueValid = false;
				errors.defaultValueError = this.props.t("errors.default_value_cannot_be_less_than_min_value");
			}
			if (errors.isMaxValid && maxValue < defaultValue && defaultValueLength > 0) {
				errors.isDefaultValueValid = false;
				errors.defaultValueError = this.props.t("errors.default_value_cannot_exceed_max_value");
			}
		} else if (formFields.attributeType === "Email") {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			let validEmail = re.test(formFields.defaultValue.toLowerCase());
			if (!validEmail && formFields.defaultValue.length > 0) {
				errors.isDefaultValueValid = false;
				errors.defaultValueError = this.props.t("errors.incorrect_email_format");
			}
		} else if (formFields.attributeType === "Tree Dropdown") {
			const error = CheckErrorInTree(formFields.treeDropdown);
			if (error !== "") {
				errors.isTreedropdownValid = false;
				errors.treedropdownError = this.props.t("treedropdownerrors." + error, { ns: "attribute/tree_dropdown" });
			}
		} else if (formFields.attributeType === "Image") {
			const { allowedFileTypes, maxNumberOfImages, maxFileSize } = formFields;
			if (!allowedFileTypes || allowedFileTypes.length === 0) {
				errors.isAllowedFileTypesValid = false;
				errors.allowedFileTypesError = this.props.t("errors.atleast_one_file_type_required");
			}
			if (maxNumberOfImages < 1) {
				errors.isNumberOfAttachmentsValid = false;
				errors.numberOfAttachmentsError = this.props.t("errors.minimum_one_required");
			} else if (maxNumberOfImages > 30) {
				errors.isNumberOfAttachmentsValid = false;
				errors.numberOfAttachmentsError = this.props.t("errors.maximum_thiry_allowed");
			}
			if (maxFileSize < 1) {
				errors.isMaxFileSizeValid = false;
				errors.maxFileSizeError = this.props.t("errors.minimum_one_required");
			} else if (maxFileSize > 10) {
				errors.isMaxFileSizeValid = false;
				errors.maxFileSizeError = this.props.t("errors.maximum_ten_allowed");
			}
		}
		return errors;
	};

	setPicklistError = (err) => {
		const { errors } = this.state;
		if (err.lengt > 0) {
			errors.isPicklistValid = false;
		} else {
			errors.isPicklistValid = true;
		}
		errors.picklistError = err;
		this.setState(errors);
	};

	setStateFieldError = (err) => {
		const { errors } = this.state;
		if (err.lengt > 0) {
			errors.isStatefieldValid = false;
		} else {
			errors.isStatefieldValid = true;
		}
		errors.statefieldError = err;
		this.setState(errors);
	};

	// Reset Part
	resetForm = async (e) => {
		const formFields = await this.getFormFields();
		const groups = this.getGroups();
		const errors = {};
		const disabled = true;
		this.defaultFormFields = { ...formFields };
		const resetFlag = !this.state.resetFlag;
		this.addUserProfileRelatedFieldsIfApplicable(formFields);
		const { triggerSetting } = formFields;
		this.setState({
			formFields,
			groups,
			errors,
			disabled,
			resetFlag,
			triggerSetting: triggerSetting ? JSON.parse(triggerSetting) : {}
		});
	};

	updateAllFormulaByEntityId = async () => {
		const { entityId, entityName, SideData, loadAttribute } = this.props;
		let reqObj = {};
		reqObj["entityId"] = entityId;
		reqObj["entityName"] = entityName;
		reqObj["oldAttrName"] = SideData.attributeName;
		reqObj["newAttrName"] = this.state.formFields.attributeName;
		reqObj["attributeId"] = SideData._id;

		const checkFormulaRequest = await callApiWithAuthorization(
			`/api/v0/entity/${entityId}/attribute-formulas`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify(reqObj)
			}
		)
		const checkFormulaResponse = await checkFormulaRequest.json();
		this.setState({
			referenceAttr: Array.from(new Set(checkFormulaResponse.message)),
			referenceChecked: true
		}, () => loadAttribute(SideData._id));
	}
	cancelRemoveDialog = (removeFormula) => {
		this.setState({ removeFormula: false, disabled: false });
		this.resetForm();

	}

	deleteFormula = async (e) => {
		this.setState({ loadFormula: true });
		this.updateForm('formula', "");
		this.updateForm('formulaJson', "");
		this.setState({ removeFormula: false });
		await this.updateAttribute(e);
		var { formFields } = this.state;
		delete formFields.formula;
		delete formFields.formulaJson;
		delete formFields.triggerSetting;
		this.setState({ formFields });
		this.setState({ loadFormula: false });
	}

	// Update part
	updateAttributeConfirm = async (e) => {
		var { formFields } = this.state;
		if (formFields.formula && this.state.triggerSetting.formulaEnabled === false) {
			this.setState({ removeFormula: true });
		} else {
			await this.updateAttribute(e);
		}
	}

	updateAttribute = async (e) => {
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		this.setState({ loading: true, disabled: true })
		const { formFields, errors } = this.state;
		formFields.attributeName = formFields.attributeName.trim()
		const { _id, attributeName } = this.props.SideData;
		const { updateAttribute, loadAttribute } = this.props;
		debugger;
		if (formFields.attributeType === "Picklist String") {
			this.handlePicklistPropertiesAndLinks(formFields);
		} else if (formFields.attributeType === "String") {
			formFields.max = formFields.max === null ? "" : formFields.max;
			formFields.min = formFields.min === null ? "" : formFields.min;
			if (formFields.pattern !== "") {
				formFields.max = ""
				formFields.min = ""
			}
		} else if (formFields.attributeType === "Number") {
			formFields.unit = formFields.unit.replace(/\"/g, '\\"');
			formFields.max = formFields.max === null ? "" : formFields.max;
			formFields.min = formFields.min === null ? "" : formFields.min;
			formFields.defaultValue = formFields.defaultValue === null ? "" : formFields.defaultValue;
		}
		if (!formFields.group) {
			formFields.group = "";
		}
		if (this.defaultFormFields.attributeLabel !== formFields.attributeLabel && formFields.attributeType === "String") {
			formFields.dummyLabel = DummyLabelHelper.getDummyLabel(formFields.attributeLabel, formFields.attributeType)
		}
		if (
			formFields.attributeType === "DateTime" ||
			formFields.attributeType === "Tags" ||
			formFields.attributeType === "Picklist String" ||
			formFields.attributeType === "State Field" ||
			formFields.attributeType === "Number" ||
			formFields.attributeType === "Mirror"
		) {
			formFields.cellFormatting = typeof formFields.cellFormatting === "string" ? formFields.cellFormatting : JSON.stringify(formFields.cellFormatting);
		}
		//this.handleAttributeLinks();


		// clear empty item from picklist - ali
		if (formFields['picklist']) {
			let values = formFields['picklist'].split('ɖ')
			values = values.filter(o => o.length > 0)
			for (let i = 0; i < values.length; i++) {
				values[i] = values[i].trim()
			}
			values = values.join('ɖ');
			formFields['picklist'] = values
		}

		if (this.defaultFormFields.attributeName !== formFields.attributeName) {
			this.handleAttributeNameChange(formFields);
		}

		try {

			const isFormulaEnabled = formFields.triggerSetting && JSON.parse(formFields.triggerSetting)?.formulaEnabled;
			if (isFormulaEnabled) {
				switch (formFields.attributeType) {
					case "String":
						formFields.defaultValue = "";
						formFields.min = "";
						formFields.max = "";
						break;
					case "Number":
						formFields.defaultValue = "";
						formFields.min = "";
						formFields.max = "";
						break;
					case "DateTime":
						formFields.defaultTime = "";
						formFields.minTime = "";
						formFields.maxTime = "";
						formFields.defaultDate = "";
						formFields.setDefaultDate = false;
						break;
					default:
						break;
				}
			}

			const properties = structuredClone(formFields);

			debugger;
			if (properties.attributeType === "Tree Dropdown") {
				const trimmedTreeDropdown = removeExtraSpaceFromTreeElement(properties['treeDropdown'])
				properties['treeDropdown'] = JSON.stringify(trimmedTreeDropdown)
			} else if (properties.attributeType === "Entity Lookup") {
				delete properties['referenceEntity'];
				delete properties['referencedAttribute'];
			} else if (properties.attributeType === "Mirror") {
				properties.references = {
					entityId: properties.entity._id,
					linkedEntityId: properties.relation._id,
					attributeId: properties.attribute._id
				}
				delete properties['entity'];
				delete properties['relation'];
				delete properties['attribute'];
			} else if (properties.attributeType === "State Field") {
				let values = this.state.formFields.statefield;
				values = values.filter(o => o.name.trim().length > 0)
				for (let i = 0; i < values.length; i++) {
					values[i]._id = values[i]._id || uuidv4()
					values[i].name = values[i].name.trim()
					values[i].order = parseInt((i + 1) * 10000000000);
				}
				properties['statefield'] = values
				formFields['statefield'] = values
				let newStates = values;
				let { rules } = this.state.formFields
				newStates = newStates
					.filter(state => state._id)
					.sort((a, b) => a.order - b.order)
					.filter((state, index, self) => index === self.findIndex((t) => t._id === state._id))
				const deletedStates = this.defaultFormFields.statefield.filter(state => !newStates.find(t => t._id === state._id))
				const rulesNeedTobeDeleted = rules.filter(rule => deletedStates.find(state => state._id === rule.fromStateId) || deletedStates.find(state => state._id === rule.toStateId))
				rules = rules.filter(rule => !rulesNeedTobeDeleted.find(t => t._id === rule._id))
				properties['rules'] = rules
				formFields['rules'] = rules
			}

			const isLabelChanged = this.defaultFormFields.attributeLabel !== formFields.attributeLabel;
			const isTooltipChanged = this.defaultFormFields.tooltip !== formFields.tooltip;

			properties['isLabelChanged'] = isLabelChanged;
			properties['isTooltipChanged'] = isTooltipChanged;
			properties.projectId = this.props.project._id;
			const attribute = await updateAttributeNode(_id, properties);
			if (attributeName !== formFields.attributeName) {
				this.updateAllFormulaByEntityId();
			}
			formFields.languages = attribute.languages;
			if (formFields.attributeType === "Mirror") {
				if (this.defaultFormFields.attribute._id !== formFields.attribute._id) {
					formFields.entity = formFields.entity;
					formFields.relation = formFields.relation;
					formFields.attribute = formFields.attribute;
				}
			} else if (formFields.attributeType === "State Field") {
				debugger;
				formFields.statefield = attribute.statefield;
			}
			if (attribute instanceof Array && attribute.length === 0) {
				throw "error";
			}
			const saveFormFields = { ...formFields };
			const attributeWithCellFormatting = ["DateTime", "Tags", "Picklist String", "State Field", "Number"];
			if (
				attributeWithCellFormatting.includes(formFields.attributeType) ||
				(
					formFields.attributeType === "Mirror" &&
					attributeWithCellFormatting.includes(formFields.attribute.attributeType)
				)
			) {
				saveFormFields.cellFormatting = JSON.parse(saveFormFields.cellFormatting);
				formFields.cellFormatting = JSON.parse(formFields.cellFormatting);
			}
			this.defaultFormFields = { ...formFields };
			const disabled = this.disableSave(formFields, errors);
			this.setState({
				formFields,
				errors,
				disabled,
			});
			updateAttribute(_id, saveFormFields);
		} catch (e) {
			console.error(e);
			const { errors } = this.state;
			errors.isTransactionValid = false;
			errors.transactionError = "Something went wrong. Please refresh the page and try again.";
			this.setState({
				errors,
			});
		} finally {
			this.setState({ loading: false });
			this.setState({
				showWarnigDialogForMultiSelect: false,
			})
			if (this.props.mutators && this.props.mutators.setFormsWithChanges) {
				this.props.mutators.setFormsWithChanges(prevValue => ({
					...prevValue,
					attributeForm: false
				}));
			}
		}
	};

	handleAttributeNameChange = (formFields) => {
		const isLabelSame = this.defaultFormFields.attributeLabel === formFields.attributeLabel;
		const isTooltipSame = this.defaultFormFields.tooltip === formFields.tooltip;
		const isDescriptionSame = this.defaultFormFields.description === formFields.description;

		if (isLabelSame) {
			formFields.attributeLabel = formFields.attributeName;
		}

		if (isTooltipSame) {
			formFields.tooltip = formFields.attributeName;
		}

		if (isDescriptionSame) {
			formFields.description = formFields.attributeName;
		}
	}

	// Update links / other properties
	handlePicklistPropertiesAndLinks = (formFields) => {
		const currentPicklist = formFields.picklist.split(",").filter((option) => option !== "");
		if (
			currentPicklist.length > 15 ||
			(formFields.multiSelect === true &&
				this.props.SideData.multiSelect === false)
		) {
			unlinkPicklistAttribute(this.props.SideData._id);
		}
		formFields["picklist"] = currentPicklist.join(",");
	};

	//
	toggleFields = () => {
		this.syncChangeToLocalStorage(!this.state.showAdditionalFields);
		this.setState({
			showAdditionalFields: !this.state.showAdditionalFields,
		});
	};

	syncChangeToLocalStorage = (value) => {
		const { entityId: id } = this.props;
		const { _id: attributeId } = this.props.SideData;
		const entityConfigLocalStorageString = localStorage.getItem("entity-config");
		const entityConfig = entityConfigLocalStorageString === null ? {} : JSON.parse(entityConfigLocalStorageString);
		if (entityConfig[id] === undefined) {
			entityConfig[id] = {};
		}
		if (entityConfig[id][attributeId] === undefined) {
			entityConfig[id][attributeId] = {};
		}
		entityConfig[id][attributeId]["showMoreAttributeProperties"] = value;
		localStorage.setItem("entity-config", JSON.stringify(entityConfig));
	};

	// Save and continue part

	getDisabled() {
		return this.state.disabled;
	}

	toggleSaveAndContinueDialog = (e) => {
		this.setState({
			showSaveAndContinueDialog: !this.state.showSaveAndContinueDialog,
		});
	};

	updateAttributeAndContinue = async (e) => {
		await this.updateAttributeConfirm(e);
		this.toggleSaveAndContinueDialog();
		if (this.state.removeFormula === false) {
			this.props.selectNextAttribute();
		}
	};

	cancelUpdatingAttribute = (e) => {
		this.toggleSaveAndContinueDialog();
		// this.props.selectNextAttribute();
	};

	// Save As Attribute Template part
	toggleOverwriteTemplateDialog = () => {
		this.setState({
			showOverwriteTemplateDialog: !this.state.showOverwriteTemplateDialog,
		});
	};

	toggleWarnigDialogForMultiSelect = () => {
		const multiSelect = this.state.formFields.multiSelect;
		this.updateForm("multiSelect", !multiSelect);
		this.setState({
			showWarnigDialogForMultiSelect: !this.state.showWarnigDialogForMultiSelect,
		});
	};

	createAttributeTemplate = async (e) => {
		const { organisationId } = this.props;
		const { formFields } = this.state;
		const { attributeName: LookupName, attributeType: lookupType, defaultValue, ...otherProperties } = formFields;
		this.setState({
			loading: true
		})
		try {
			const attributeTemplates = await getAttributeTemplates(organisationId);
			const lookupNameInUse = attributeTemplates.findIndex((template) => template.LookupName.toLowerCase() === LookupName.toLowerCase()) > -1;

			if (lookupNameInUse) {
				this.toggleOverwriteTemplateDialog();
				this.setState({
					loading: false
				})
			} else {
				const sysName = this.getLookupSysName(LookupName, attributeTemplates);
				const properties = {
					LookupName,
					lookupType,
					sysName,
					...otherProperties,
				}
				await createAttributeTemplate(organisationId, properties)
				this.props.ShowNotification(this.props.t("template_created_successfully"));
				this.setState({
					loading: false
				})
			}
		} catch (e) {
			const { errors } = this.state;
			const error = e.message;
			errors.isTransactionValid = false;
			errors.transactionError = this.props.t("errors.transaction_error");
			this.setState({
				errors,
				loading: false
			});
		}
	};

	overwriteTemplate = async () => {
		const { organisationId } = this.props;
		const { formFields } = this.state;
		const { attributeName: LookupName, attributeType: lookupType, defaultValue, ...otherProperties } = formFields;
		this.setState({
			loading: true
		})
		try {
			const attributeTemplates = await getAttributeTemplates(organisationId);
			const lookup = attributeTemplates.find((template) => template.LookupName.toLowerCase() === LookupName.toLowerCase());
			const properties = {
				LookupName,
				lookupType,
				...otherProperties,
			}
			await updateAttributeTemplate(lookup._id, properties)
			this.toggleOverwriteTemplateDialog();
			this.setState({
				loading: false
			})
			this.props.ShowNotification(ATTRIBUTE_LABEL + " template updated successfully");
		} catch (e) {
			const { errors } = this.state;
			errors.isTransactionValid = false;
			errors.transactionError = this.props.t("errors.transaction_error");
			this.setState({
				errors,
				loading: false
			});
			this.toggleOverwriteTemplateDialog();
		}
	};

	getLookupSysName = (lookupName, lookups) => {
		let sysName = lookupName.toLowerCase().replace(/[^0-9a-zA-Z]/g, "");
		let counter = 0;
		for (let lookupIndex = 0; lookupIndex < lookups.length; lookupIndex++) {
			if (lookups[lookupIndex].LookupName === lookupName) {
				++counter;
				sysName = lookupName + String(counter);
				lookupIndex = 0;
			}
		}
		return sysName;
	};
}

export default withTranslation([
	"attribute/property_panel",
	"attribute/tree_dropdown",
]
	, {
		withRef: true
	})(SidebarAttribute);
